import { render, staticRenderFns } from "./course.vue?vue&type=template&id=c92aa69c&scoped=true"
import script from "./course.vue?vue&type=script&lang=js"
export * from "./course.vue?vue&type=script&lang=js"
import style0 from "./course.vue?vue&type=style&index=0&id=c92aa69c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92aa69c",
  null
  
)

export default component.exports